export const isDemoMockAnalysis = (analysis) => (
  analysis?.provider?.model === "mock-demo"
  || (Array.isArray(analysis?.evidence) && analysis.evidence.some((item) => (
    typeof item?.ref === "string" && item.ref.startsWith("demo-mock:")
  )))
);

export default isDemoMockAnalysis;
